import { Filter } from "src/framework/commons/FilterUtil";
import { Option, OptionWithImage, PosicaoModulo, Projeto, FormProjetoOffGridType, PropostaValueType, TiposInversorTypes, FormProjetoOffGridValidationsType, FormProjetoOffGridModalsType } from "./types";
import Paisagem from './assets/paisagem.png'
import Retrato from './assets/retrato.png'
import { FieldFilter, LESS_CRITERIA_LIST_ITEM, LESS_EQUAL_CRITERIA_LIST_ITEM, MORE_CRITERIA_LIST_ITEM, MORE_EQUAL_CRITERIA_LIST_ITEM } from "src/framework/store/DataGridStore";
import { ID_CONTROLADOR, ID_INVERSOR, ID_INVERSOR_CARREGADOR, ID_MICROINVERSOR, TGrupoCategoria } from "../componentes/types";

export const NOME_CLIENTE_MAX_LENGTH = 100

export const ID_ATRIBUTO_BATERIA_TIPO_CHUMBO = 1
export const ID_ATRIBUTO_BATERIA_TIPO_LITIO = 2

export const MIN_VALUE_CICLOS_CHUMBO = 50
export const MAX_VALUE_CICLOS_CHUMBO = 850

export const VALUE_CICLOS_LITIO = 6000

export const FINANCEIRA_BV_ID = 1
export const FINANCEIRA_SANTANDER_ID = 2
export const FINANCEIRA_PARCEIRO_ID = 3

export const TIPO_SERVICO_REVENDA = "revenda"
export const TIPO_SERVICO_TURNKEY = "intelbras"
export const ETAPA_VENDA_REVISAO = "sla_engenharia";

export const VALOR_MULTIPLO_CABO = 25
export const NUM_MAXIMO_INVERSORES = 20
export const NUM_MINIMO_INVERSORES = 2

export const SIMULTANEIDADE_MAX = 80
export const SIMULTANEIDADE_MIN = 10

export const CATEGORIA_COMPONENTE_STRINGBOX = 4
export const CATEGORIA_COMPONENTE_VERTICAIS = 200

export const PROJETOS_CUSTO_ANUAL_MANUTENCAO_GERADOR_PARAM = 'PROJETOS_CUSTO_ANUAL_MANUTENCAO_GERADOR'
export const MODULO_POTENCIA_MAXIMA_ATTR = 'MODULO_POTENCIA_MAXIMA'
export const MODULO_POTENCIA_MINIMA_ATTR = 'MODULO_POTENCIA_MINIMA'
export const MODULO_POWER_ATTR = 'MODULO_POTENCIA'
export const MODULO_MODULO_TENSAO_VOC_ATTR = 'MODULO_TENSAO_VOC'
export const INVERSOR_TENSAO_ATTR_ID = "INVERSOR_TENSAO"
export const INVERSOR_TIPO_CONEXAO_ATTR_ID = "INVERSOR_TIPO_CONEXAO"
export const INVERTER_MAX_POWER_ATTR = 'INVERSOR_POTENCIA_MAXIMA_SAIDA'
export const CONTROLADOR_MAXIMA_POTENCIA_FOTOVOLTAICA_ATTR = 'CONTROLADOR_MAXIMA_POTENCIA_FOTOVOLTAICA'
export const INVERTER_MAX_POWER_INPUT_ATTR = 'INVERSOR_POTENCIA_MAXIMA_ENTRADA'
export const INVERSOR_ONDA_POTENCIA_MAXIMA_ATTR = 'INVERSOR_ONDA_POTENCIA_MAXIMA'
export const INVERSOR_CARREGADOR_POTENCIA_MAXIMA_SAIDA_ATTR = 'INVERSOR_CARREGADOR_POTENCIA_MAXIMA_SAIDA'
export const INVERSOR_CARREGADOR_POTENCIA_MAXIMA_FV_ATTR = 'INVERSOR_CARREGADOR_POTENCIA_MAXIMA_FV'
export const INVERSOR_CARREGADOR_TENSAO_MAXIMA_ENTRADA= "INVERSOR_ONDA_TENSAO_MAXIMA_ENTRADA";
export const PROJETOS_ITENS_SEM_SUGESTAO_INSTALACAO = 'PROJETOS_ITENS_SEM_SUGESTAO_INSTALACAO'

export const fatorPerdasLimites: {[index: number]: { min: number; max: number; default: number; }} = {
    [ID_INVERSOR]: { min: 15, max: 50, default: 15 },
    [ID_MICROINVERSOR]: { min: 18, max: 50, default: 20 }
  }

export enum SITUACAO {
    PENDENTE = 'pendente',
    REGISTRADO = 'registrado',
    ANALISE = 'analise',
    INTEGRADO = 'integrado',
    EXPIRADO = 'expirado',
}

export const TIPOS_INVERSOR_OPTIONS = [
    {
      text: 'Inversor',
      value: ID_INVERSOR,
    },
    {
      text: 'Microinversor',
      value: ID_MICROINVERSOR,
    }]

export const TIPOS_SOLUCAO_OPTIONS = [
    {
      text: 'Controlador',
      value: ID_CONTROLADOR,
    },
    {
      text: 'Carregador',
      value: ID_INVERSOR_CARREGADOR,
    }
]

export const LISTA_SITUACAO_PROJETOS_VERTICAIS = [
    {
        text: "Pendentes",
        value: "pendente",
    },
    {
        text: "Revisão",
        value: "revisao",
    },
    {
        text: "Pausado",
        value: "pausado",
    },
    {
        text: "Expirados",
        value: "expirado",
    },
    {
        text: "Finalizados",
        value: "finalizado",
    },
    {
        text: "Cancelados",
        value: "cancelado",
    }
];

export const DEFAULT_PRIORIDADE_PROJETOS_VERTICAIS = "baixa";

export const LISTA_TIPOS_PROJETOS = [
    {
        text: "Verticais",
        value: "vertical",
    },
    {
        text: "Dimensionados",
        value: "dimensionado",
    },
    {
        text: "Personalizados",
        value: "personalizado",
    },
];

export const LISTA_PRIORIDADE_PROJETOS_VERTICAIS = [
    {
        text: "Baixa",
        value: "baixa",
    },
    {
        text: "Média",
        value: "media",
    },
    {
        text: "Alta",
        value: "alta",
    },
];

export const LISTA_ETAPA_VENDA_PROJETOS_VERTICAIS = [
    {
        text: "SLA Engenharia",
        value: "sla_engenharia",
    },
    {
        text: "Pré-Orçamento",
        value: "pre_orcamento",
    },
    {
        text: "Aguardando Pagamento",
        value: "aguardando_pagamento",
    },
    {
        text: "Negociação",
        value: "negociacao",
    },
    {
        text: "Aguardando Faturamento",
        value: "aguardando_faturamento",
    },
    {
        text: "Faturado",
        value: "faturado",
    },
    {
        text: "Em transito",
        value: "em_transito",
    },
    {
        text: "Entregue",
        value: "entregue",
    }

];

export const POSICAO_MODULO: OptionWithImage<PosicaoModulo>[] = [
    { text: 'Paisagem', value: 'paisagem', image: Paisagem },
    { text: 'Retrato', value: 'retrato', image: Retrato }
]

export const SEGMENTO_LIST = [
    { text: "On Grid", value: "distribuicao_ongrid" },
    { text: "Off Grid", value: 'distribuicao_offgrid' },
    { text: "Ambos", value: 'distribuicao_ongrid,distribuicao_offgrid,distribuicao_ambos' },
]

export const ORIGEM_LIST = [
    { text: "Antigo Ambiente Plataforma", value: "V1" },
    { text: "Novo Ambiente Plataforma", value: "V2" },
]

export const PROJETO_MIGRADO = [
    { text: "Sim", value: "true" },
    { text: "Não", value: "false" },
]

export const EXPIRADO_LIST = [
    { text: "Sim", value: 'expirado' },
    { text: "Não", value: 'n_expirado' },
    { text: "Ambos", value: 'ambos' },
]

export const KITS_LIST = [
    { text: "Sim", value: 'kit' },
    { text: "Não", value: 'n_kit' },
    { text: "Ambos", value: 'ambos' },
]

export const SITUACAO_PAGAMENTOS_LIST = [
    { text: "Aguardando Pagamento", value: 'aguardando_pagamento' }, 
    { text: "Pago", value: 'pago' }, 
    { text: "Recusado", value: 'recusado' }, 
    { text: "Cancelado", value: 'cancelado' }, 
    { text: "Expirado", value: 'expirado' }, 
    { text: "Em análise de financiamento", value: 'analise_financiamento' }, 
    { text: "Aguardando análise de documento", value: 'aguardando_analise_documentacao' },
    { text: "Documentação aprovada", value: 'documentacao_aprovada' },
    { text: "Aguardando emissão de NF", value: 'aguardando_emissao_nf' }, 
    { text: "Aguardando confirmação do pagamento", value: 'aguardando_confirmacao_pagamento' },
    { text: "Aguardando análise do comprovante", value: 'comprovante_pagamento' },
]

export const ETAPA_VENDA = [
    { text: "Pré-orçamento", value: "pre_orcamento" },
    { text: "Proposta Final", value: 'negociacao' },
    { text: "Projeto cancelado", value: 'cancelado' },
    { text: "Pagamento reconhecido", value: 'reconhecido' },
    { text: "Processando Informaçoes de Pedido", value: 'faturado' },
    { text: "Em Trânsito", value: 'em_transito' },
    { text: "Produto Entregue", value: 'entregue' },
    { text: "Projeto Finalizado", value: 'finalizado' },
    { text: "Em Análise de Financiamento", value: 'analise_financiamento' },
]
export const ETAPAS_LIST = [
    { text: "Pré-orçamento", value: 'pre_orcamento'},
    { text: "Proposta Final", value: 'proposta_final'},
    { text: "Projeto cancelado", value: 'cancelado'},
    { text: "Pagamento reconhecido", value: 'pagamento_reconhecido'},
    { text: "Processando Informações do Pedido", value: 'processando_informacoes_pedido'},
    { text: "Em Trânsito", value: 'em_transito'},
    { text: "Produto Entregue", value: 'entregue'},
    { text: "Projeto Finalizado", value: 'finalizado'},
]

export const TIPO_SERVICO = [
    { text: "Produto", value: "", disabled: false },
    { text: "Produto + serviço", value: TIPO_SERVICO_REVENDA, disabled: false },
    { text: "Turnkey", value: TIPO_SERVICO_TURNKEY, disabled: false },
]

export const TIPO_SERVICO_RS = [
    { text: "Produto", value: "" },
    { text: "Turnkey", value: TIPO_SERVICO_TURNKEY },
]

export const PROPOSTA_OPTIONS: Option<PropostaValueType>[] = [
  {
    text: 'Gerador com instalação',
    value: 'gerador-com-instalacao'
  },
  {
    text: 'Apenas gerador sem instalação',
    value: 'gerador-sem-instalacao'
  }
]

export const GARANTIA_TEMPO_UNIDADE: Option[] = [
  {
    text: 'Anos',
    value: 'anos'
  },
  {
    text: 'Meses',
    value: 'meses'
  }
]

export const PROJETO_FINAME = [
    { text: "Sim", value: 'finame' },
    { text: "Não", value: 'n_finame' },
    { text: "Ambos", value: 'ambos' },
]

export const DEFAULT_PROJETO: Projeto = {
    id: 0,
    cep_encontrado: false,
    regioes: [],
    codigo_venda: null,
    situacao: "pendente",
    servico: null,
    titulo: "",
    segmento: 'distribuicao_ongrid',
    setor: null,
    potencia: 0,
    potencia_inversor: 0,
    valor: 0.0,
    valor_servico: 0.0,
    valor_servico_pis_cofins: 0.0,
    valor_total_produtos: 0.0,
    percentual_comissao_distribuidor: 0,
    percentual_comissao_revenda: 0,
    observacao: "",
    prioridade: "baixa",
    etapa_venda: '',
    cliente_proposta: "",
    email_proposta: '',
    cpf_cnpj_proposta: "",
    telefone_proposta: "",
    endereco_proposta: "",
    valor_pedido: 0.0,
    valor_desconto: 0.0,
    distribuidor_id: null,
    distribuidor: null,

    cidade_id: 0,
    cidade: undefined,

    revenda_id: null,
    revenda: null,
    pagamentos: [],
    pedidos: [],
    ev_id: null,
    ev: undefined,
    analista_id: null,
    analista: undefined,
    auto_comissao: true,
    nota_fiscal_triangular: false,
    solicitacao: {
        unidade_consumidora: false,
        endereco: undefined,
        limitacao_observacao: "",
        limitacao_projeto_id: null,
        projeto_id: undefined
    },

    limitacao_projeto: {
        descricao: "",
        id: undefined,
    },
    anexos: [],
    visita_tecnica_texto: undefined,
    confirmado_por: undefined,
    data_visita_tecnica: undefined,

    cep: "",
    numero: "",
    bairro: "",
    modulosList: [],
    inversoresList: [],
    tipo_inversor: null,
    inversor_modelo: null,
    acessorios: [],
    tipo_proposta: PROPOSTA_OPTIONS.find(item => item.value === 'gerador-sem-instalacao') || null,
    tempo_garantia_servico: 0,
    tempo_garantia_servico_unidade: null,
    tipo_faturamento: 'cliente',
    termo_aceito: false,
    texto_termo_aceito: '',
    resultado_calculos: null,
    preco_kwh_com_imposto: 0,
    tipo: 'dimensionado',
    recebe_servico: false,
    latitude: 0,
    longitude: 0,
    tensao_rede: null,
    numero_fases: null,
    fator_perdas: 0,
    tipo_projeto: { text: 'Grupo B', value: 'grupo-b' },
    fileiras: [{ fileiras: 1, posicao_modulo: POSICAO_MODULO.find(pm => pm.value === 'retrato') || null, quantidade_modulos: 0, tipo_estrutura: null }],
    solucao_sugerida: null,
    potencia_desejada: 0,
    valor_anual_manutencao: 0,
    consumo_meses: [],
    sugestoes: {
        modulo: {
            id: 0,
            quantidade: 0,
            categoria_componentes_id: 0,
        },
        estrutura: [],
        inversores: [],
        acessorios: [],
    },
    estrutura_calculadas: [],
    modo_calculo: 'potencia',
    consumo_data_final: null,
    consumo_data_inicial: null,
    isEdit: false,
    estruturas_edicao: [],
    fileiras_edicao: [],
    simulacao_financiamento: null,
    lista_termo_simulacao_financiamento: null,
    lista_termo_simulacao_financiamento_original: null,
    old_componentes_edicao: [],
    old_estado_id: '',
    vendedor_interno: undefined,
    valor_margem_produtos: 0,
    simultaneidade: 0,
    geradores_kits: [],
    tempo_vida: '25 anos',
    carrinho_id: 0,
    showRoiPayback: false,
    tipo_proposta_projeto: undefined,
    endereco: undefined,
    dados_termo: undefined,
    documentos_servico: undefined,
    componentes_finame: [],
    tarifa_concessionaria_id: 0,
    dados_concessionaria_payback: null,
    impostos_payback: null,
    isTrocaUf: false,
    percentual_comissao_distribuidor_sap: 0,
    percentual_comissao_revenda_sap: 0
}

export const NOVO_PROJETO_ENGENHARIA: Partial<Projeto> = {
    tipo: 'vertical', 
    segmento: 'vertical_ongrid',
    recebe_servico: true,
    engenharia: true,
}

export const SITUACAO_FIELD: FieldFilter = {
    name: "situacao",
    index: 1,
    criteriaList: [],
}

export const CIDADE_FIELD: FieldFilter = {
    name: "cidade_id",
    index: 2,
    criteriaList: []
}

export const DISTRIBUIDOR_FIELD: FieldFilter = {
    name: "distribuidor_id",
    index: 3,
    criteriaList: []
}

export const REVENDA_FIELD: FieldFilter = {
    name: "revenda_id",
    index: 4,
    criteriaList: []
}


export const EV_FIELD: FieldFilter = {
    name: "ev_id",
    index: 5,
    criteriaList: []
}

export const DATA_ETAPA_INICIO_FIELD: FieldFilter = {
    name: "data_etapa_venda_more_equal",
    index: 6,
    criteriaList: []
}

export const DATA_ETAPA_FINAL_FIELD: FieldFilter = {
    name: "data_etapa_venda_less_equal",
    index: 7,
    criteriaList: []
}

export const RANGE_PONTENCIA_INICIO_FIELD: FieldFilter = {
    name: "potencia_more_equal",
    index: 8,
    criteriaList: [
        MORE_EQUAL_CRITERIA_LIST_ITEM,
        MORE_CRITERIA_LIST_ITEM,
    ]
}

export const RANGE_PONTENCIA_FINAL_FIELD: FieldFilter = {
    name: "potencia_less_equal",
    index: 9,
    criteriaList: [
        LESS_EQUAL_CRITERIA_LIST_ITEM,
        LESS_CRITERIA_LIST_ITEM,
    ]
}

export const ETAPA_VENDA_FIELD: FieldFilter = {
    name: "etapa_venda_in",
    index: 10,
    criteriaList: []
}

export const ESTADOS_FIELD: FieldFilter = {
    name: "estados",
    index: 11,
    criteriaList: []
}

export const CIDADES_FIELD: FieldFilter = {
    name: "cidades",
    index: 12,
    criteriaList: []
}

export const PRIORIDADE_FIELD: FieldFilter = {
    name: "prioridade",
    index: 13,
    criteriaList: []
}

export const ORIGEM_FIELD: FieldFilter = {
    name: "origem",
    index: 14,
    criteriaList: []
}

export const TIPO_FIELD: FieldFilter = {
    name: "tipo_in",
    index: 15,
    criteriaList: []
}

export const FILTER: Filter[] = [
    {
        field: "codigo_venda_in",
        value: "",
        label: "Código venda (Use vírgula como separador)",
        isDefaultSearch: true,
        isNumber: false,
    },
    {
        field: SITUACAO_FIELD.name,
        value: null,
    },
    {
        field: CIDADE_FIELD.name,
        value: null,
        arrayField: "id"
    },
    {
        field: DISTRIBUIDOR_FIELD.name,
        value: null,
        arrayField: "id"
    },
    {
        field: REVENDA_FIELD.name,
        value: null,
        arrayField: "id"
    },
    {
        field: EV_FIELD.name,
        value: null,
        arrayField: "id"
    },
    {
        field: DATA_ETAPA_INICIO_FIELD.name,
        value: null
    },
    {
        field: DATA_ETAPA_FINAL_FIELD.name,
        value: null
    },
    {
        field: RANGE_PONTENCIA_INICIO_FIELD.name,
        value: null
    },
    {
        field: RANGE_PONTENCIA_FINAL_FIELD.name,
        value: null
    },
    {
        field: ETAPA_VENDA_FIELD.name,
        value: null
    },
    {
        field: ESTADOS_FIELD.name,
        value: null
    },
    {
        field: CIDADES_FIELD.name,
        value: null
    },
    {
        field: PRIORIDADE_FIELD.name,
        value: null
    },
    {
        field: ORIGEM_FIELD.name,
        value: "V2"
    },
    {
        field: TIPO_FIELD.name,
        value: "vertical",
    }
];

export const TIPO_FATURAMENTO = [
    { text: "Para cliente final", value: "cliente" },
    { text: "Para revenda", value: "integrador" },
    { text: "Operação triangular/Venda à ordem", value: "integrador_cliente" },
];

// vertical = Vertical
// personalizado = Personalizado
// dimensionado = Dimensionado
// avulso = Avulso  
// kit = Kit
// misto = Misto
export const TIPO_PROJETO = [
    { text: "Vertical", value: "vertical" },
    { text: "Personalizado", value: "personalizado" },
    { text: "Dimensionado", value: "dimensionado" },
    { text: "Avulso", value: "avulso" },
    { text: "Kit", value: "kit" },
    { text: "Misto", value: "misto" },
]

export const SITUACAO_PEDIDO = [
    {
        text: "Pendente",
        value: "pendente",
    },
    {
        text: "Finalizado",
        value: "finalizado",
    },
    {
        text: "Cancelado",
        value: "cancelado",
    }       
]

//envio_pagamento = Envio pagamento
//aguardando_pagamento = Aguardando pagamento
//negociacao = Negociação
//pagamento_aprovado = Pagameno aprovado
//gestao_pedidos = Gestão de pedidos
//aguardando_faturamento = Aguardando faturamento
//faturado = Faturado
//em_transito = Em transito
//entregue = Entregue
export const SITUACAO_ETAPADA_PEDIDO = [
    {
        text: "Envio pagamento",
        value: "envio_pagamento",
    },
    {
        text: "Aguardando pagamento",
        value: "aguardando_pagamento",
    },
    {
        text: " Negociação",
        value: "negociacao",
    },
    {
        text: "Pagameno aprovado",
        value: "pagamento_aprovado",
    },
    {
        text: "Gestão de pedidos",
        value: "gestao_pedidos",
    },
    {
        text: "Aguardando faturamento",
        value: "aguardando_faturamento",
    },
    {
        text: "Faturado",
        value: "faturado",
    },
    {
        text: "Em transito",
        value: "em_transito",
    },
    {
        text: "Entregue",
        value: "entregue",
    },
]
export const LISTA_TIPOS_DESCONTOS_PROJETO = [    
    {
        text: "Distribuidor",
        value: "distribuidor",
    },
    {
        text: "Intelbras",
        value: "intelbras",
    },
    {
        text: "Revenda",
        value: "revenda",
    },
]

export const STATUS_COMISSIONAMENTO = [
    {
        text: "Aguardando Documentação",
        value: "aguardando_documentacao",
    },
    {
        text: "Documentação enviada/processando",
        value: "documentacao_enviada_processando",
    },
    {
        text: "Documentação Aprovada",
        value: "documentacao_aprovada",
    },
    {
        text: "Aguardando Finalização do Projeto",
        value: "aguardando_finalizacao",
    }
]
export const DEFAULT_STATUS_COMISSIONAMENTO = 
    {
        text: "Aguardando Documentação",
        value: "aguardando_documentacao",
    }

export enum DOCUMENTOS_SERVICO_TYPE {
    ORDEM_SERVICO = "ordem_servico",
    NF_SERVICO_INSTALACAO = "nf_servico_instalacao",
    IDENTIFICACAO_CLIENTE = "identificacao_cliente",
    ART_TRT_PROJETO = "art_trt_projeto",
}

export const POTENCIA_MINIMA_ENGENHARIA = Number(process.env.REACT_APP_POTENCIA_MINIMA_ENGENHARIA || 1000);
export const POTENCIA_MINIMA_VERTICAL = Number(process.env.REACT_APP_POTENCIA_MINIMA_VERTICAL || 405);
export const FIELDS_PROJETO = [
    "solucao_sugerida",
    "componentes",
    "codigo_venda",
    "titulo",
    "distribuidor_id",
    "revenda_id",
    "status_projeto",
    "status_projeto_pagamento",
    "expirado",
    "tipo_faturamento",
    "tipo",
    "cliente_proposta",
    "cpf_cnpj_proposta",
    "email_proposta",
    "endereco",
    "dados_concessionaria_payback",
    "simultaneidade",
    "potencia",
    "preco_kwh",
    "tipo_proposta",
    "percentual_comissao_distribuidor",
    "valor_servico",
    "valor_margem",
    "valor_desconto",
    "valor_servico_pis_cofins",
    "valor_projeto",
    "termos_aceite",
    "aceitou_termos",
    "inversor_tensao",
    "inversor_tipo_conexao",
    "tipo_inversor",
    "inversor_modelo",
    "termos_projeto",
    "previsao_faturamento",
    "fator_perdas",
    "potencia_desejada",
    "nome_modulo",
    "disposicao",
    "valor_produtos",
    "valor_produtos_desconto",
    "valor_total",
    "consumo",
    "revenda",
    "distribuidor",
    "tensao",
    "concessionaria",
    "valor_instalacao",
    "codigo_servico",
    "estabelecimento_id",
    "justificativa_valor_servico",
    "valor_watt_servico",
    "equipamentos",
    "total_consumo_diario_w",
    "tipo_bateria",
    "autonomia_banco_baterias",
    "tensao_saida",
    "total_carga_equipamentos_kw",
    "taxa_descarga",
    "tipo_solucao",
]
export const STATUS_PROJETO = [
    { text: "Pré-orçamento", value: "pre_orcamento" },
    { text: "Proposta Final", value: "proposta_final" },
    { text: "Proposta Final", value: "negociacao" },
    { text: "Projeto Cancelado", value: "cancelado" },
    { text: "Pagamento Reconhecido", value: "pagamento_reconhecido" },
    { text: "Processando Informações do Pedido", value: "processando_informacoes_pedido" },
    { text: "Em Trânsito", value: "em_transito" },
    { text: "Produto Entregue", value: "entregue" },
    { text: "Projeto Finalizado", value: "finalizado" },
];
export const STATUS_PROJETO_PAGAMENTO = [
    { text: "Pago", value: "pago" },
    { text: "Pago", value: "finalizado" },
    { text: "Parcialmente pago", value: "parcialmente_pago" },
    { text: "Aguardando Pagamento", value: "aguardando_pagamento" },
    { text: "Aguardando análise da documentação", value: "aguardando_analise_documentacao" },
    { text: "Aguardando emissão da NF", value: "aguardando_emissao_nf" },
    { text: "Aguardando emissão da NF", value: "emissao_nota" },
    { text: "Aguardando confirmação do pagamento", value: "comprovante_pagamento_pendente" },
    { text: "Aguardando análise do comprovante", value: "comprovante_pagamento" },
    { text: "Recusado", value: "recusado" },
    { text: "Cancelado", value: "cancelado" },
    { text: "Aguardando confirmação de pagamento", value: "aguardando_confirmacao_pagamento" },
    { text: "Em análise de financiamento", value: "analise_financiamento" },
    { text: "Expirado", value: "expirado" },
    { text: "Aguardando Pagamento", value: "pendente" },
];
export const LISTA_TIPO_PROJETO = [
    {
        text: "Vertical",
        value: "vertical",
    },
    {
        text: "Dimensionado",
        value: "dimensionado",
    },
    {
        text: "Personalizado",
        value: "personalizado",
    },
    {
        text: "Kit",
        value: "kit",
    },
    {
        text: "Avulso",
        value: "avulso",
    }
];
export const FIELDS_DESCONTOS = [
    "percentual_distribuidor",
    "percentual_revenda",
    "percentual_intelbras",
    "valor_intelbras",
    "justificativa",
    "desconto_total",
    "usuario"
];

export const FIELDS_NOTAS = [
    "valor",
    "numero",
    "peso_bruto",
    "itens",
    "estado",
    "bairro",
    "cidade",
    "complemento",
    "numero_endereco",
    "logradouro",
    "observacao"
];
export const FIELDS_PEDIDOS = [
    "pedido_erp",
    "valor_pedido",
    "nome_transportadora",
    "cnpj_transportadora",
    "componentes",
    "itens"
];

export const TIPO_INVERSOR_ID: {[index: number]: TiposInversorTypes | "" } = {
    [ID_INVERSOR]: 'string',
    [ID_MICROINVERSOR]: 'micro',
    0: ""
}

export const DEFAULT_PROJETO_OFFGRID_VALIDATIONS: FormProjetoOffGridValidationsType = {
    autonomia_bancos_bateria: { status: true, helper: '' },
    tipo_bateria: { status: true, helper: '' },
    modulo: { status: true, helper: '' },
    estrutura: { status: true, helper: '' },
    fileiras: { status: true, helper: '' }
}

export const DEFAULT_PROJETO_OFFGRID_MODALS: FormProjetoOffGridModalsType = {
    equipamentos: false,
    drawerInformacoes: false
}

export const DEFAULT_PROJETO_OFFGRID: FormProjetoOffGridType = {
    id: 0,
    listagem_baterias_status: false,
    cep_encontrado: false,
    regioes: [],
    codigo_venda: null,
    servico: null,
    titulo: null,
    segmento: 'distribuicao_offgrid',
    geracao_necessaria_kw: 0,
    geracao_necessaria_w: 0,
    potencia_fotovoltaica: 0,
    reativar: false,
    recalcular: false,
    valor: 0.0,
    valor_servico: 0.0,
    valor_servico_pis_cofins: 0.0,
    cliente_proposta: "",
    email_proposta: '',
    cpf_cnpj_proposta: "",
    telefone_proposta: "",
    endereco_proposta: "",
    distribuidor_id: 0,
    distribuidor: null,
    cidade_id: 0,
    cidade: undefined,
    revenda_id: null,
    revenda: null,
    ev_id: null,
    ev: undefined,
    assistente: undefined,
    supervisor_id: null,
    assistente_id: null,
    analista_id: null,
    analista: null,
    cep: "",
    numero: "",
    bairro: "",
    modulo_selecionado: null,
    modulos: [],
    inversores: [],
    acessorios: [],
    resultado_calculos: null,
    tipo: 'dimensionado',
    recebe_servico: false,
    latitude: 0,
    longitude: 0,
    fileiras: [],
    estruturas_calculadas: [],
    isEdit: false,
    vendedor_interno: undefined,
    endereco: undefined,
    autonomia_banco_bateria: 0,
    tipo_bateria: null,
    clonar_projeto: false,
    tensao_saida: null,
    estado_id: "",
    estado: undefined,
    estado_original: undefined,
    isTrocaUf: false,

    estruturas: [],
    todas_estruturas: [],

    equipamentos: [],
    total_consumo_diario_w: 0,
    total_consumo_diario_kw: 0,
    fator_demanda: null,

    estrutura_selecionada: null,

    solucao_calculada: {
        baterias: [],
        controladores: [],
        inversores: [],
        modulo: null,
    },

    baterias: [],
    valor_minimo_servico: 0,
    tipo_proposta: PROPOSTA_OPTIONS.find(item => item.value === 'gerador-sem-instalacao') || null,
    justificativa_valor_servico: '',
    old_componentes_edicao: [],
    old_estado_id: '',
}

export const DEFAULT_PROJETO_AVULSO: Projeto = {
    id: 0,
    cep_encontrado: false,
    regioes: [],
    codigo_venda: null,
    situacao: "pendente",
    servico: null,
    titulo: null,
    segmento: 'distribuicao_ongrid',
    setor: null,
    potencia: 0,
    potencia_inversor: 0,
    valor: 0.0,
    valor_servico: 0.0,
    valor_servico_pis_cofins: 0.0,
    valor_total_produtos: 0.0,
    percentual_comissao_distribuidor: 0,
    percentual_comissao_revenda: 0,
    observacao: "",
    prioridade: "baixa",
    etapa_venda: '',
    cliente_proposta: "",
    email_proposta: '',
    cpf_cnpj_proposta: "",
    telefone_proposta: "",
    endereco_proposta: "",
    valor_pedido: 0.0,
    valor_desconto: 0.0,
    distribuidor_id: null,
    distribuidor: null,

    cidade_id: 0,
    cidade: undefined,

    revenda_id: null,
    revenda: null,
    pagamentos: [],
    pedidos: [],
    ev_id: null,
    ev: undefined,
    analista_id: null,
    analista: undefined,
    auto_comissao: true,
    nota_fiscal_triangular: false,
    solicitacao: {
        unidade_consumidora: false,
        endereco: undefined,
        limitacao_observacao: "",
        limitacao_projeto_id: null,
        projeto_id: undefined
    },

    limitacao_projeto: {
        descricao: "",
        id: undefined,
    },
    anexos: [],
    visita_tecnica_texto: undefined,
    confirmado_por: undefined,
    data_visita_tecnica: undefined,

    cep: "",
    numero: "",
    bairro: "",
    modulosList: [],
    inversoresList: [],
    tipo_inversor: null,
    inversor_modelo: null,
    acessorios: [],
    tipo_proposta: PROPOSTA_OPTIONS.find(item => item.value === 'gerador-sem-instalacao') || null,
    tempo_garantia_servico: 0,
    tempo_garantia_servico_unidade: null,
    tipo_faturamento: 'cliente',
    termo_aceito: false,
    texto_termo_aceito: '',
    resultado_calculos: null,
    preco_kwh_com_imposto: 0,
    tipo: 'avulso',
    recebe_servico: false,
    latitude: 0,
    longitude: 0,
    tensao_rede: null,
    numero_fases: null,
    fator_perdas: 0,
    tipo_projeto: { text: 'Grupo B', value: 'grupo-b' },
    fileiras: [{ fileiras: 1, posicao_modulo: POSICAO_MODULO.find(pm => pm.value === 'retrato') || null, quantidade_modulos: 0, tipo_estrutura: null }],
    solucao_sugerida: null,
    potencia_desejada: 0,
    valor_anual_manutencao: 0,
    consumo_meses: [],
    sugestoes: {
        modulo: {
            id: 0,
            quantidade: 0,
            categoria_componentes_id: 0,
        },
        estrutura: [],
        inversores: [],
        acessorios: [],
    },
    estrutura_calculadas: [],
    modo_calculo: 'potencia',
    consumo_data_final: null,
    consumo_data_inicial: null,
    isEdit: false,
    estruturas_edicao: [],
    fileiras_edicao: [],
    simulacao_financiamento: null,
    lista_termo_simulacao_financiamento: null,
    lista_termo_simulacao_financiamento_original: null,
    old_componentes_edicao: [],
    old_estado_id: '',
    vendedor_interno: undefined,
    valor_margem_produtos: 0,
    simultaneidade: 0,
    geradores_kits: [],
    tempo_vida: '25 anos',
    carrinho_id: 0,
    showRoiPayback: false,
    tipo_proposta_projeto: undefined,
    endereco: undefined,
    dados_termo: undefined,
    documentos_servico: undefined,
    componentes_finame: [],
    tarifa_concessionaria_id: 0,
    dados_concessionaria_payback: null,
    impostos_payback: null,
    isTrocaUf: false,
    percentual_comissao_distribuidor_sap: 0,
    percentual_comissao_revenda_sap: 0
}

export const PREFIXO_HIBRIDO = 'HIBRI';

export const ORDEM_GRUPO_CATEGORIAS: Record<TGrupoCategoria, number> = {
    modulos: 1,
    inversores: 2,
    controladores: 3,
    baterias: 4,
    itens_estrutura: 5,
    acessorios: 6,
    iluminacao: 7,
    verticais: 8
};
